module.exports = __webpack_public_path__ + "static/media/notification-active-icon.94d47264.png";